import {
  EcommerceShoppingCartClient,
  UpdateCartItemQuantityRequest,
} from "@lib/ShiOneClient";
import { useApi } from "@utils/useApi";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Toast } from "shared-ui/src/components/Toast";
import { invalidateCart } from "@features/ecommerce/cart/cartQueryKeys";

export interface UpdateShoppingCartItemQtyArgs {
  lineNumber: number;
  quantity: number;
}

/**
 * Updates the quantity of a single shopping-cart line. Invalidate-only (no optimistic
 * cache write) to match the existing cart mutation convention; the cart query is
 * re-fetched on settle so the UI reconciles to server truth on success or failure.
 */
const useUpdateShoppingCartItemQty = () => {
  const queryClient = useQueryClient();
  const api = useApi(EcommerceShoppingCartClient);

  return useMutation<void, Error, UpdateShoppingCartItemQtyArgs>({
    mutationFn: async ({ lineNumber, quantity }) =>
      api.updateShoppingCartItemQuantity(
        lineNumber,
        new UpdateCartItemQuantityRequest({ quantity }),
      ),
    onError: (error) => {
      Toast(`Failed to update quantity. Reason: ${error?.message}`, true, 7000);
    },
    onSettled: async () => {
      await invalidateCart(queryClient);
    },
  });
};

export default useUpdateShoppingCartItemQty;
